import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import ContentWrapper from '../../Components/ContentWrapper';
import { RobotLoading } from '../../Components/Loading';
import { isLoading, isLogin } from '../../Redux/user-profile/selectors';
import ConfirmDek63 from '../ConfirmAdmission';

class Landing extends Component {
  render() {
    const { isLoading, isLogin } = this.props;
    if (isLoading) {
      return (
        <ContentWrapper>
          <RobotLoading />
        </ContentWrapper>
      );
    }
    if (isLogin) return <Redirect to={ConfirmDek63.location} />;
    return <Redirect to={'/login'} />;
  }
}

export default connect(state => ({
  isLoading: isLoading(state),
  isLogin: isLogin(state),
}))(Landing);
